import { Outlet } from "react-router-dom";

import { AdminSubNav } from "@/pages/dashboard/AdminSubNav";
import { AdminForbiddenView } from "@/pages/dashboard/admin/AdminForbiddenView";
import { AdminViewModelProvider } from "@/pages/dashboard/admin/AdminViewModelContext";
import { useDashboardRoles } from "@/pages/dashboard/useDashboardRoles";

export function AdminLayout() {
  const { canViewReports, canViewFieldNotesAdmin, canCreateOnBehalf, isAdmin } = useDashboardRoles();
  if (!canViewReports) return <AdminForbiddenView />;
  return (
    <>
      <AdminSubNav
        canViewReports={canViewReports}
        canViewFieldNotesAdmin={canViewFieldNotesAdmin}
        canCreateOnBehalf={canCreateOnBehalf}
        isAdmin={!!isAdmin}
      />
      <AdminViewModelProvider>
        <Outlet />
      </AdminViewModelProvider>
    </>
  );
}
